import type { BankAccountKind, CurrencyCode } from '../types';

export const BANK_ACCOUNT_KIND_OPTIONS: { value: BankAccountKind; label: string }[] = [
  { value: 'account', label: 'Account' },
  { value: 'depot', label: 'Depot' },
];

export function bankAccountKindLabel(kind: BankAccountKind | undefined): string {
  return kind === 'depot' ? 'Depot' : 'Account';
}

export const CURRENCY_OPTIONS: { value: CurrencyCode; label: string }[] = [
  { value: 'EUR', label: 'EUR — Euro' },
  { value: 'USD', label: 'USD — US Dollar' },
  { value: 'GBP', label: 'GBP — British Pound' },
  { value: 'CHF', label: 'CHF — Swiss Franc' },
  { value: 'JPY', label: 'JPY — Japanese Yen' },
  { value: 'AUD', label: 'AUD — Australian Dollar' },
  { value: 'CAD', label: 'CAD — Canadian Dollar' },
  { value: 'SEK', label: 'SEK — Swedish Krona' },
  { value: 'NOK', label: 'NOK — Norwegian Krone' },
  { value: 'DKK', label: 'DKK — Danish Krone' },
  { value: 'PLN', label: 'PLN — Polish Złoty' },
  { value: 'CZK', label: 'CZK — Czech Koruna' },
];
